export default {
  id: 176,
  title: 'Target #176 - Castlevania',
  url: 'https://cssbattle.dev/play/176',
  colors: ['#A6D6AE', '#3A0F09', '#BB9213'],
  solution:
    '<p d><p c><p a><p b><p e><p f><style>body{background:#a6d6ae}p{position:fixed}p[a],p[b],p[c]{top:4;left:85;border:40px solid #a6d6ae;border-bottom-color:#3a0f09;transform:scaleY(1.5)}p[e],p[f]{border-radius:1in 1in 0 0;background:#bb9213}p[b]{left:235}p[c]{top:54;left:150;border-width:50;transform:scaleY(.7)}p[d]{top:104;left:100;width:200;height:120;background:#3a0f09}p[e]{top:114;left:115;width:20;height:25;box-shadow:150px 0 #bb9213}p[f]{top:174;left:170;width:60;height:50}</style>',
}
